import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * Clavier arabe partagé — version event-based (compatible signals).
 * Émet le caractère à insérer (charAdded) et la demande de suppression (backspace),
 * le parent applique la modification sur sa propre source (signal, FormControl, etc).
 * S'affiche seulement quand [open] = true.
 */
@Component({
  selector: 'app-arabic-keyboard',
  standalone: false,
  templateUrl: './arabic-keyboard.component.html',
})
export class ArabicKeyboardComponent {
  @Input() open = false;
  @Output() charAdded = new EventEmitter<string>();
  @Output() backspace = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  arabicKeyboardLayout = [
    ['ض', 'ص', 'ث', 'ق', 'ف', 'غ', 'ع', 'خ', 'ح', 'ج', 'د'],
    ['ش', 'س', 'ي', 'ب', 'ل', 'ا', 'ت', 'ن', 'م', 'ك', 'ط'],
    ['ئ', 'ء', 'ؤ', 'ر', 'ى', 'ة', 'و', 'ز', 'ظ', '.', '،'],
  ];

  addCharacter(char: string): void { this.charAdded.emit(char); }
  removeLastCharacter(): void { this.backspace.emit(); }
  close(): void { this.closed.emit(); }
}
